import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { onboarding } from "@/lib/onboarding";
import type { ReactNode } from "react";

function FullScreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--colour-background)]">
      <div className="w-10 h-10 rounded-full bg-[var(--colour-surface-raised)] animate-pulse" />
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading, profileLoading, hasOnboarded } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenSpinner />;
  if (!user) return <Navigate to="/signin" state={{ from: location }} replace />;
  if (profileLoading) return <FullScreenSpinner />;
  const onboarded = hasOnboarded || onboarding.isComplete();
  if (!onboarded && !location.pathname.startsWith("/onboarding")) {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}

export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { user, loading, profileLoading, hasOnboarded } = useAuth();
  if (loading) return <FullScreenSpinner />;
  if (user) {
    if (profileLoading) return <FullScreenSpinner />;
    const onboarded = hasOnboarded || onboarding.isComplete();
    return <Navigate to={onboarded ? "/explore" : "/onboarding"} replace />;
  }
  return <>{children}</>;
}
